import { disableWaapi } from '~/helpers/animate';

export const DEFAULT_PRESENCE_ANIMATION = {
  animate: { opacity: 1 },
  exit: { opacity: 0 },
  initial: { opacity: 0 },
  transition: { duration: 0.2 },
  onUpdate: disableWaapi,
};
